import { render } from "./ExamStudentAnswersView.vue?vue&type=template&id=ded37b24&scoped=true"
import script from "./ExamStudentAnswersView.vue?vue&type=script&lang=js"
export * from "./ExamStudentAnswersView.vue?vue&type=script&lang=js"

import "./ExamStudentAnswersView.vue?vue&type=style&index=0&id=ded37b24&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ded37b24"]])

export default __exports__